import { render } from "./Menu.vue?vue&type=template&id=72d483ba&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=72d483ba&scoped=true&lang=scss"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d483ba"]])

export default __exports__